export type LandingCurrency = 'EUR' | 'USD';

export const LANDING_CURRENCY_FALLBACK: LandingCurrency = 'EUR';

export function normalizeCountryCode(country: string | null | undefined): string | null {
    if (!country) {
        return null;
    }
    const trimmed = country.trim();
    if (!trimmed) {
        return null;
    }
    return trimmed.toUpperCase();
}

/** Maps a detected country to the currency used by the backend wallet. */
export function mapCountryToLandingCurrency(countryCode: string | null | undefined): LandingCurrency {
    const normalized = normalizeCountryCode(countryCode);
    if (normalized === 'US') {
        return 'USD';
    }
    return LANDING_CURRENCY_FALLBACK;
}

export function applyLandingCurrencyToPricing(root: ParentNode, currency: LandingCurrency): void {
    const currencyAttribute: Lowercase<LandingCurrency> = currency === 'EUR' ? 'eur' : 'usd';
    const pricingRoot = root.querySelector<HTMLElement>('[data-pricing-root]');

    if (pricingRoot) {
        pricingRoot.dataset.currency = currency;
    }

    root.querySelectorAll<HTMLElement>('[data-pricing-amount]').forEach((amount: HTMLElement): void => {
        const value = amount.dataset[currencyAttribute];
        if (value) {
            amount.textContent = value;
        }
    });
}

function getGeolocationApiUrl(): string {
    if (import.meta.env.DEV) {
        return '';
    }
    const isBlog = typeof window !== 'undefined' && window.location.hostname.startsWith('blog.');
    return import.meta.env.VITE_API_URL || (isBlog ? 'https://minifil.com' : 'http://localhost:3001');
}

export async function fetchLandingCurrencyFromGeolocation(): Promise<LandingCurrency> {
    const apiUrl = getGeolocationApiUrl();
    const response = await fetch(`${apiUrl}/api/geolocation`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error(`Geolocation API returned ${response.status}`);
    }

    const data: { countryCode?: string | null } = await response.json();
    return mapCountryToLandingCurrency(data.countryCode);
}
